<template>
  <v-card :flat="flat">
    <v-card-title v-if="title">{{ title }}</v-card-title>
    <v-card-text>
      <v-chart
        :option="mergedOptions"
        :autoresize="true"
        :style="{ height: height, width: width }"
        @click="handleClick"
        @dblclick="handleDblClick"
      />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'BaseChart',
  props: {
    title: {
      type: String,
      default: ''
    },
    height: {
      type: String,
      default: '400px'
    },
    width: {
      type: String,
      default: '100%'
    },
    flat: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      required: true
    },
    showToolbox: {
      type: Boolean,
      default: true
    },
    showDataZoom: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    vuetifyColors () {
      return [
        this.$vuetify.theme.primary,
        this.$vuetify.theme.accent,
        this.$vuetify.theme.secondary,
        this.$vuetify.theme.success,
        this.$vuetify.theme.warning,
        this.$vuetify.theme.info
      ]
    },
    defaultOptions () {
      const baseOptions = {
        color: this.vuetifyColors,
        textStyle: {
          fontFamily: 'Roboto, sans-serif'
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: this.showDataZoom ? '15%' : '3%',
          containLabel: true
        }
      }

      if (this.showToolbox) {
        baseOptions.toolbox = {
          feature: {
            saveAsImage: {
              title: 'Export PNG',
              pixelRatio: 2
            },
            dataZoom: {
              title: {
                zoom: 'Zoom',
                back: 'Reset Zoom'
              }
            },
            restore: {
              title: 'Restore'
            }
          },
          right: '20px'
        }
      }

      if (this.showDataZoom) {
        baseOptions.dataZoom = [
          {
            type: 'inside',
            start: 0,
            end: 100
          },
          {
            start: 0,
            end: 100,
            height: 20
          }
        ]
      }

      return baseOptions
    },
    mergedOptions () {
      return this.mergeDeep(this.defaultOptions, this.options)
    }
  },
  methods: {
    mergeDeep (target, source) {
      const output = Object.assign({}, target)
      if (this.isObject(target) && this.isObject(source)) {
        Object.keys(source).forEach(key => {
          if (this.isObject(source[key])) {
            if (!(key in target)) {
              Object.assign(output, { [key]: source[key] })
            } else {
              output[key] = this.mergeDeep(target[key], source[key])
            }
          } else {
            Object.assign(output, { [key]: source[key] })
          }
        })
      }
      return output
    },
    isObject (item) {
      return item && typeof item === 'object' && !Array.isArray(item)
    },
    handleClick (params) {
      this.$emit('chart-click', params)
    },
    handleDblClick (params) {
      this.$emit('chart-dblclick', params)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/charts/BaseChart.vue